<template>
  <div>
    <v-data-table
      mobile-breakpoint="0"
      item-key="id"
      :headers="headers"
      :items="documentTypes"
      v-bind="this.$attrs"
      loading-text="Đang Tải"
      :loading="loading"
      :items-per-page="-1"
      hide-default-footer
    >
      <template v-slot:[`footer.page-text`]="items">
        {{ items.pageStart }} - {{ items.pageStop }} trên
        {{ items.itemsLength }}
      </template>
      <template v-slot:body="props">
        <draggable
          :list="props.items"
          tag="tbody"
          :move="onMoveCallback"
          :clone="onCloneCallback"
          :disabled="disableDrag"
          @end="onDropCallback"
        >
          <DataTableRowHandler v-for="(item, index) in props.items" :key="index" :item="item" :headers="headers">
            <template v-slot:[`item.drag`]="">
              <v-icon>mdi-drag</v-icon>
            </template>
            <template v-slot:[`item.title`]="{ item }">
              <router-link style="text-decoration: none" :to="`/${type}/${item.id}`">
                {{ item.title }}
              </router-link>
            </template>
            <template v-slot:[`item.description`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <div style="width: 100%">
                    <span v-bind="attrs" v-on="on">
                      <div class="truncate-text">
                        {{ item.description }}
                      </div>
                    </span>
                  </div>
                </template>
                <span>{{ item.description }}</span>
              </v-tooltip>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <div v-if="isEditDocument">
                <router-link style="text-decoration: none" :to="`/${type}/${item.id}`">
                  <v-icon color="primary">mdi-eye</v-icon>
                </router-link>
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" icon>
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item>
                      <v-list-item-title style="cursor: pointer" @click="edit(item)">
                        <v-icon>mdi-pencil</v-icon>
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-title style="cursor: pointer" @click="remove(item)">
                        <v-icon>mdi-delete</v-icon></v-list-item-title
                      >
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
              <div v-else>
                <router-link style="text-decoration: none" :to="`/${type}/${item.id}`">
                  <v-icon color="primary">mdi-eye</v-icon>
                </router-link>
              </div>
            </template>
          </DataTableRowHandler>
        </draggable>
      </template>
    </v-data-table>

    <!-- edit dialog -->
    <v-dialog v-model="editDialog" scrollable width="700">
      <v-card>
        <v-toolbar color="primary" dense class="elevation-0" dark>
          <v-toolbar-title>Sửa loại tài liệu</v-toolbar-title>
          <v-spacer />
          <v-btn icon dark @click="cancel">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-form ref="form">
            <v-text-field
              v-model="title"
              :rules="[$rules.required]"
              label="Tên mục"
              class="required mt-6"
              outlined
              dense
            ></v-text-field>
            <v-textarea v-model="description" label="Mô tả" outlined></v-textarea>
          </v-form>
        </v-card-text>
        <v-divider />
        <v-card-actions class="pa-4">
          <v-btn outlined @click="cancel">HUỶ</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="editSave">LƯU</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import { Document } from '../../plugins/api'
import draggable from 'vuedraggable'
import DataTableRowHandler from '@/components/basic/DataTableRowHandler.vue'

const originHeaders = [
  {
    text: '',
    value: 'drag',
    align: 'left',
    sortable: false,
    width: 50
  },
  {
    text: 'Đầu mục / Thư mục',
    value: 'title',
    align: 'left',
    sortable: false
  },
  {
    text: 'Mô tả',
    value: 'description',
    align: 'left',
    sortable: false
  },
  // {
  //   text: 'index',
  //   value: 'index',
  //   align: 'left',
  //   sortable: false
  // },
  {
    text: 'Số lượng file',
    value: 'fileNo',
    align: 'center',
    sortable: false
  },
  {
    text: 'Thao tác',
    value: 'actions',
    align: 'left',
    sortable: false
  }
]

export default {
  data() {
    return {
      headers: originHeaders,
      loading: false,
      editDialog: false,
      title: '',
      description: '',
      editingItem: null,
      itemMoving: {}
    }
  },
  props: {
    type: {
      type: String,
      default: () => 'teacher-document'
    }
  },
  components: {
    draggable,
    DataTableRowHandler
  },
  computed: {
    ...mapState('DocumentTypes', ['documentTypes']),
    ...mapGetters('auth', ['profile', 'role', 'user', 'isEditDocument']),
    disableDrag() {
      return this.loading || this.role.type === 'teacher' || this.role.type === 'inspector'
    }
  },
  methods: {
    ...mapActions('DocumentTypes', ['fetchDocumentTypes', 'updateDocumentType', 'removeDocumentType', 'updateIndex']),
    async refresh(query) {
      this.loading = true
      query = query || {}
      if (this.type === 'teacher-document' && this.role.type === 'teacher') {
        query.createdTeacher = this.profile.id
      }
      await this.fetchDocumentTypes({ ...query, type: this.type })

      this.loading = false
    },
    cancel() {
      this.editDialog = false
    },
    edit(item) {
      this.editingItem = item
      this.editDialog = true
      this.title = item.title
      this.description = item.description
    },
    async editSave() {
      if (!this.$refs.form.validate()) return

      try {
        this.$loading.active = true
        await this.updateDocumentType({ id: this.editingItem.id, title: this.title, description: this.description })
        this.$alert.updateSuccess()

        this.editingItem = null
        this.title = null
        this.description = null
        this.editDialog = false
      } catch (error) {
        this.$alert.updateError()
      } finally {
        this.$loading.active = false
      }
    },
    async remove(item) {
      this.$dialog.confirm({
        title: 'Xóa thư mục tài liệu',
        text: `Bạn có Chắc Chắn muốn xóa thư mục tài liệu này không ?`,
        okText: 'Có',
        cancelText: 'Hủy',
        done: async () => {
          this.$loading.active = true
          try {
            const documents = await Document.fetch({ documentType: item.id, _limit: 1 })
            if (documents && documents.length > 0) {
              this.$alert.error('Không thể xóa thư mục có chứa tài liệu')
              return
            }

            await this.removeDocumentType(item)
            this.$alert.deleteSuccess()
          } catch (error) {
            this.$alert.deleteError()
          } finally {
            this.$loading.active = false
          }
        }
      })
    },

    onCloneCallback(item) {
      // Create a fresh copy of item
      const cloneItem = JSON.parse(JSON.stringify(item))
      this.itemMoving = cloneItem
      return cloneItem
    },
    onMoveCallback(evt, originalEvent) {
      // const item = evt.draggedContext.element
      // const itemIdx = evt.draggedContext.futureIndex

      return true
    },
    async onDropCallback(evt, originalEvent) {
      const oldIndex = evt.oldIndex + 1
      const newIndex = evt.newIndex + 1
      if (oldIndex !== newIndex) {
        try {
          this.loading = true
          await this.updateIndex({ itemMoving: this.itemMoving, oldIndex, newIndex })
        } catch (error) {
          console.error('error: ', error)
          this.$alert.error('Đã có lỗi xảy ra, vui lòng thử lại!')
        } finally {
          this.loading = false
        }
      }
    }
  },
  async created() {
    await this.refresh({})
  },
  mounted() {
    if (!this.isEditDocument) {
      this.headers = [
        {
          text: 'Đầu mục / Thư mục',
          value: 'title',
          align: 'left',
          sortable: false
        },
        {
          text: 'Mô tả',
          value: 'description',
          align: 'left',
          sortable: false
        },
        // {
        //   text: 'index',
        //   value: 'index',
        //   align: 'left',
        //   sortable: false
        // },
        {
          text: 'Số lượng file',
          value: 'fileNo',
          align: 'center',
          sortable: false
        },
        {
          text: 'Thao tác',
          value: 'actions',
          align: 'left',
          sortable: false
        }
      ]
    }
  },
  filters: {}
}
</script>

<style scoped>
.truncate-text {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1; /* number of lines to show */
  -webkit-box-orient: vertical;
}
</style>
